import React from 'react';
import { Button } from './styled.tab';
import { ITab } from './../../../@types/tabs';
import { Headline5 } from '../../typography';

export function Tab ({ title, isSelected, onClick, variant = 'default' }: ITab) {
  const isBooster = variant === 'booster';
  const textColor = isBooster
    ? isSelected
      ? 'verdigris'
      : 'platinum'
    : 'verdigris';

  return (
    <>
      <Button active={isSelected} onClick={onClick} variant={variant}>
        <Headline5 color={textColor} ellipsis={true}>
          {title}
        </Headline5>
      </Button>
    </>
  );
}
